<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.url' :placeholder="$t('请输入域名') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.issue' :placeholder="$t('请输入期号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'><Select clearable v-model='searchConf.isXg' clearable
                                                      :placeholder="$t('资料类型') " style='width:120px'>
              <Option :value="'0'">{{ $t('澳门') }}</Option>
              <Option :value="'1'">{{ $t('香港') }}</Option>
            </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('编辑') }}</span>
      </p>
      <span style="color: red">{{ extraParams['open'] }} </span>

      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" label-position="left"
            :label-width="150">
        <p :prop="key" v-for="(value, key) in extraParams['data']">
          <FormItem :label="value['name']">
            <Input v-model="value['code']" :placeholder="value['name']" style="width: 300px;"></Input>
            <Button type="info" @click="getParams(extraParams['id'],key)" class="margin-left-10">{{
                $t('重新生成')
              }}
            </Button>
            <span style="margin-left: 15px ;color: red">{{ value['isZhong'] }}</span>

          </FormItem>
        </p>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/LhcManage/LhcAmIndexZhiliao'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data() {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('域名'),
        key: 'url',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('类型'),
        key: 'position',

        minWidth: 80,
        align: 'center'
      }, {
        title: this.$t('期号'),
        key: 'issue',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                this.getParams(params.row.id)
              }
            }
          }, this.$t('编辑本期首页资料')),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0,
        config_user: '',
      },
      windowAddItem: { //弹窗数据绑定
        id: 0,
      },
      windowAddValidate: {//窗口校验规则
      },
      //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcAmIndexZhiliao/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcAmIndexZhiliao/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcAmIndexZhiliao/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
    this.searchConf.isXg = this.$route.params.isXg
    this.searchConf.url = this.$route.params.url ? this.$route.params.url : ''
    this.searchConf.issue = this.$route.params.issue ? this.$route.params.issue : ''
  },
  mounted() {
    // this.getParams()

  },
  methods: {
    preAdd() {
      // this.getParams(6209);
    },
    getParams(id, key = '') {
      let vm = this
      getParams(id, key).then(response => {
        this.extraParams = response.data.data
        vm.windowAdd.show = true
      })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      add(vm.extraParams).then(response => {
        vm.$Message.success(response.data.msg)
        vm.getList()
        vm.windowAddCancel()
      }).catch(() => {
        vm.windowAdd.loading = false
      })
    },
  }
}
</script>
